module.exports = __webpack_public_path__ + "img/logo-skale-5-blanc.ed61cd80.svg";